var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 92 119"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Forma 1",
  d: "M79.42 19.255c-1.12-1.1-2.27-2.215-3.4-3.35s-2.26-2.27-3.36-3.388C64.78 4.517 60.09 0 55.2 0H18.4A18.38 18.38 0 0 0 0 18.308v82.384A18.38 18.38 0 0 0 18.4 119h55.2A18.38 18.38 0 0 0 92 100.692V36.615c0-4.86-4.55-9.529-12.58-17.36zm3.38 81.437a9.181 9.181 0 0 1-9.2 9.154H18.4a9.181 9.181 0 0 1-9.2-9.154V18.308a9.179 9.179 0 0 1 9.2-9.154l33.53-.018c3.32.843 3.27 4.9 3.27 8.957v13.945a4.6 4.6 0 0 0 4.6 4.577h13.8c4.59 0 9.2.023 9.2 4.577v59.5z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rounded Rectangle 4050",
  x: 21,
  y: 63,
  width: 52,
  height: 9,
  rx: 4.5,
  ry: 4.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rounded Rectangle 4050 copy",
  x: 21,
  y: 81,
  width: 52,
  height: 9,
  rx: 4.5,
  ry: 4.5
})));
export default SvgFile;